import { useEffect, useState } from "react";

import scrollImg from "../assets/scroll-up-img.svg";

export default function ScrollTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="scroll-to-top-wrapper">
      {isVisible && (
        <a href="#" onClick={scrollToTop} className="scroll-to-top-btn">
          <img src={scrollImg} alt="scroll" />
        </a>
      )}
    </div>
  );
}
